import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Button, Spinner, Switch } from "@material-tailwind/react";

import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { ToastContainer, toast } from "react-toastify";

import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";

import DepotForm from "./Depot_form";
import { getAllDepotsApi } from "api/depot";
import { deleteDepotApi } from "api/depot";
import { updateDepotCouterStatusApi, updateStockDgValidationStatusApi } from "api/depot";

function ClientTable({ accessList }) {
  const [depotFormAction, setDepotFormAction] = useState("show");
  const [showDepotForm, setDepotClientForm] = useState(false);
  const [depotList, setDepotList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDepot, setSelectedDepot] = useState([]);
  const [filerFormData, setFilerFormData] = useState({
    Name: "",
    Origin: "",
  });

  useEffect(() => {
    getTableData(filerFormData.Name, filerFormData.Origin);
  }, []);

  const getTableData = async (Name, Origin) => {
    try {
      const response = await getAllDepotsApi(Name, Origin);

      setDepotList(response);
      setIsLoading(true);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStockCompterChange = async (status, id) => {
    try {
      await updateDepotCouterStatusApi(!status, id)
      getTableData(filerFormData.Name, filerFormData.Origin);
      Swal.fire("Modifiée", "", "success");
    }
    catch (err) {
      console.log(err);
    }
  }
  const handleStockValidationDgChange = async (status, id) => {
    try {
      await updateStockDgValidationStatusApi(!status, id)
      getTableData(filerFormData.Name, filerFormData.Origin);
      Swal.fire("Modifiée", "", "success");
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleDeleteDepot = (id) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await deleteDepotApi(id);
            getTableData(filerFormData.Name, filerFormData.Origin);
            Swal.fire("Supprimée", "", "success");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleDepotModal = (action, data) => {
    try {
      setDepotClientForm(!showDepotForm);
      setDepotFormAction(action);

      setSelectedDepot(data);
    } catch (err) {
      console.log(err);
    }
  };

  const hadleShowToast = (type, message) => {
    if (type === "success") {
      setDepotClientForm(!showDepotForm);
      getTableData(filerFormData.Name, filerFormData.Origin);

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <ToastContainer />
      <Dialog size="xl" open={showDepotForm} handler={handleDepotModal}>
        <DialogHeader>
          <p className="w-full text-center">
            {depotFormAction === "add"
              ? "Nouveau dépôt"
              : depotFormAction === "edite"
              ? "Modifier le dépôt"
              : "Voir les details de dépôt"}
          </p>
        </DialogHeader>
        <DialogBody>
          <DepotForm
            closePopup={handleDepotModal}
            depotFormAction={depotFormAction}
            showToast={hadleShowToast}
            selectedDepot={selectedDepot}
          />
        </DialogBody>
      </Dialog>

      <header className="relative flex flex-col items-center justify-between md:flex-row">
        <div className="mb-5 text-xl font-bold text-navy-700 dark:text-white md:mb-0"></div>
        {accessList.Add && (
          <Button
            onClick={() => handleDepotModal("add", null)}
            className="linear mb-5 rounded-[10px] bg-gray-500 px-4 py-2 text-xs font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:mb-0"
          >
            Nouveau dépôts
          </Button>
        )}
      </header>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2"></div>

      <div className="mt-8 overflow-x-scroll">
        {isLoading ? (
          <div className="flex w-full items-center justify-center">
            <Spinner className="h-12 w-12" />
          </div>
        ) : (
          <div
          className="mt-8 overflow-x-scroll"
          style={{ height: "50vh", overflowY: "scroll" }}
        >
          <table className="w-full">
            <thead>
              <tr>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Dépôt</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Nom</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Compteur de stock</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Validation DG</p>
                </th>
                <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                  <p className="text-xs tracking-wide text-gray-600">Actions</p>
                </th>
              </tr>
            </thead>

            <tbody>
              {depotList.map((el) => (
                <tr>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el.Name}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {el.Origin}
                    </p>
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    {/* <Switch checked={emptyICE} onChange={handleEmptyICEChange} /> */}
                    <Switch checked={el.StockCounter} onChange={() => handleStockCompterChange(el.StockCounter, el._id)} />
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    {/* <Switch checked={emptyICE} onChange={handleEmptyICEChange} /> */}
                    <Switch checked={el.DgValidation} onChange={() => handleStockValidationDgChange(el.DgValidation, el._id)} />
                  </td>
                  <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      <div className="flex">
                        {accessList.Read && (
                          <IoEyeSharp
                            size={20}
                            color="gray"
                            className="cursor-pointer"
                            onClick={() => handleDepotModal("show", el)}
                          />
                        )}
                        {accessList.Update && (
                          <HiPencilAlt
                            size={20}
                            color="#236571"
                            className="ml-4 mr-4 cursor-pointer"
                            onClick={() => handleDepotModal("edite", el)}
                          />
                        )}
                        {accessList.Delete && (
                          <FaTrash
                            size={20}
                            color="#cf503f"
                            className="cursor-pointer"
                            onClick={() => handleDeleteDepot(el._id)}
                          />
                        )}
                      </div>
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        )}
      </div>
    </Card>
  );
}

export default ClientTable;
